'use client'

import { createContext, useContext, type ReactNode } from 'react'

import type { PurchaseFlowContextValue } from '../model/flow'

const PurchaseFlowContext = createContext<PurchaseFlowContextValue>({
  enabled: false,
  flowId: null,
  flowType: null,
  returnTo: null,
})
interface PurchaseFlowProviderProps {
  value: PurchaseFlowContextValue
  children: ReactNode
}
export function PurchaseFlowProvider(props: PurchaseFlowProviderProps) {
  return <PurchaseFlowContext.Provider value={props.value}>{props.children}</PurchaseFlowContext.Provider>
}
export function usePurchaseFlow(): PurchaseFlowContextValue {
  return useContext(PurchaseFlowContext)
}
export function usePaymentFlowRevamp(): boolean {
  return usePurchaseFlow().enabled
}
